/* Cart mutations own the busy state; animation never holds up checkout. */
(() => {
  if (window.EidoCartState) return;
  const sources = new Set();
  const saved = new Map();
  const actions = '[data-eido-cdb-primary], [data-co-primary], [name="checkout"], a[href$="/checkout"], [data-co-apple-pay-button]';
  const wallets = '[data-eido-cdb-wallets-inner], .eido-co__apple-pay-native, .additional-checkout-buttons, .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart';
  const busy = () => sources.size > 0;
  const sync = () => {
    const blocked = busy();
    for (const [element, state] of saved) {
      if (!blocked || !element.isConnected) {
        if ('disabled' in element) element.disabled = state.disabled;
        element.inert = state.inert;
        state.aria === null ? element.removeAttribute('aria-disabled') : element.setAttribute('aria-disabled', state.aria);
        element.removeAttribute('data-eido-cart-blocked');
        saved.delete(element);
      }
    }
    if (blocked) document.querySelectorAll(actions + ', ' + wallets).forEach(element => {
      if (!saved.has(element)) saved.set(element, { disabled: element.disabled, inert: element.inert, aria: element.getAttribute('aria-disabled') });
      element.setAttribute('data-eido-cart-blocked', 'true');
      element.setAttribute('aria-disabled', 'true');
      if (element.matches(wallets)) element.inert = true;
      if ('disabled' in element) element.disabled = true;
    });
  };
  window.EidoCartState = {
    busy, sync,
    set(source, value) {
      value ? sources.add(source) : sources.delete(source);
      sync();
      document.dispatchEvent(new CustomEvent('eido:cart-busy', { detail: { busy: busy() } }));
    },
  };
  document.addEventListener('click', event => {
    if (busy() && event.target instanceof Element && event.target.closest(actions + ', ' + wallets)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (busy() && (event.submitter?.matches(actions) || /\/cart\/?$/.test(new URL(event.target.action, location.href).pathname))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(() => {
    sync();
  }));
})();
